import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ClaimsService } from "../services/claims.service";

@Injectable()
export class AccessGuard {
    constructor(
        private router: Router,
        private claimsService: ClaimsService
    ) {}

    canActivate() {
        const hasAccess = this.claimsService.isAdmin() == false;
        if (!hasAccess) {
            this.router.navigate(["/auth/logout"]);
        }

        return hasAccess;
    }
}
